export function openModalScroll ({ className = 'modal-opened', time = 300 } = {}) {
  // let {className = 'modal-opened', time = 300} = objOfPArams
  if (window.modalTimeOut) {
    clearTimeout(window.modalTimeIn)
  }
  if (document.body.style.top === '') {
    window.modalTimeIn = setTimeout(() => {
      document.body.dataset.scrollTop = window.pageYOffset
      document.body.style.top = -window.pageYOffset + 'px'
      document.body.classList.add(className)
      // console.log('this.scrollTop', window.pageYOffset)
    }, time)
  }
}
export function closeModalScroll ({ className = 'modal-opened', time = 0 } = {}) {
  // let {className = 'modal-opened', time = 0} = objOfPArams
  if (window.modalTimeIn) {
    clearTimeout(window.modalTimeIn)
  }
  if (document.body.style.top !== '') {
    window.modalTimeOut = setTimeout(() => {
      document.body.classList.remove(className)
      document.body.style.top = ''
      window.scroll(0, document.body.dataset.scrollTop)
    }, time)
  }
}
